import { ICEMAN, LIKED } from "./tracks";
import rediscover from "../assets/images/spotify/rediscover.jpg";
import allTimeTopSongs from "../assets/images/spotify/all-time-top-songs.jpg";
import shazam from "../assets/images/spotify/shazam.jpg";

// Sylvester's Spotify library, as his screenshots show it, newest first. Covers are the artwork
// Apple has for the same albums and shows; Spotify's own playlists have theirs from the
// screenshots, or Spotify's placeholder (`icon`). `open` is the page an item opens (ICEMAN and
// Liked Songs, which play); the rest just show in the list.

const art = (path) => `https://is1-ssl.mzstatic.com/image/thumb/${path}/160x160bb.jpg`;

export const LIBRARY = [
  { id: "liked", title: LIKED.name, kind: "Playlist", by: "Sylvester", pinned: true, open: "liked" },
  { id: "iceman", title: ICEMAN.name, kind: "Album", by: ICEMAN.artist, image: ICEMAN.image, open: "iceman" },
  {
    id: "good-bad-billionaire",
    title: "Good Bad Billionaire",
    kind: "Podcast",
    by: "BBC World Service",
    image: art("Podcasts211/v4/f3/5e/bd/f35ebdfd-0f58-5e38-c730-65af2e18b41b/mza_18173551939387628789.jpg"),
  },
  {
    id: "straight-outta-cobham",
    title: "Straight Outta Cobham: The Athletic FC's Chelsea show",
    kind: "Podcast",
    by: "The Athletic",
    image: art("Podcasts221/v4/e9/6d/62/e96d629b-3759-789e-8eb8-c57e0d401a9e/mza_12913791784555847749.jpeg"),
  },
  {
    id: "the-official-podcast",
    title: "The Official Podcast",
    kind: "Podcast",
    by: "The Official Podcast",
    image: art("Podcasts211/v4/c3/a5/c3/c3a5c38f-3e83-21d7-76b1-86eb0c087ea4/mza_2756932629676299813.jpeg"),
  },
  {
    id: "sincerely-accra",
    title: "Sincerely Accra",
    kind: "Podcast",
    by: "GCR",
    image: art("Podcasts211/v4/47/1a/87/471a8742-1027-d552-efcc-25a890b0f429/mza_9321881880754383754.png"),
  },
  {
    id: "stuff-you-should-know",
    title: "Stuff You Should Know",
    kind: "Podcast",
    by: "iHeartPodcasts",
    image: art("Podcasts221/v4/aa/82/91/aa82912f-23ee-6f6a-583c-a4e993164d0e/mza_12111158076643383507.jpg"),
  },
  {
    id: "ghana-special",
    title: "Ghana Special: Modern Highlife, Afro Sounds & Ghanaian Blues 1968-81",
    kind: "Compilation",
    by: "Various Artists",
    image: art("Music122/v4/e2/02/a9/e202a915-d093-190e-6392-44046f1e5daa/5060091551336.png"),
  },
  {
    id: "rodeo",
    title: "Rodeo",
    kind: "Album",
    by: "Travis Scott",
    image: art("Music221/v4/6d/fb/f1/6dfbf17d-4032-f585-35ad-f3f9b6859cd9/886445460421.jpg"),
  },
  {
    id: "birds-in-the-trap",
    title: "Birds In The Trap Sing McKnight",
    kind: "Album",
    by: "Travis Scott",
    image: art("Music114/v4/b8/e5/27/b8e527c8-aaf4-c7b7-5562-c479458ed7d9/886446092645.jpg"),
  },
  {
    id: "abrabo",
    title: "Abrabo",
    kind: "Album",
    by: "K. Frimpong",
    image: art("Music122/v4/cb/e0/11/cbe01189-fe2a-22c1-dbe9-3efff6f5fde3/196626793331.jpg"),
  },
  {
    id: "the-blue-album",
    title: "The Blue Album",
    kind: "Album",
    by: "K. Frimpong",
    image: art("Music211/v4/96/f1/2f/96f12fb6-9da2-51d7-b420-97359c689a90/115719.jpg"),
  },
  {
    id: "empire",
    title: "Empire: World History",
    kind: "Podcast",
    by: "Goalhanger",
    image: art("Podcasts221/v4/99/6e/9f/996e9ffd-8fa6-1189-2ad1-402c310e853e/mza_8884204689909689127.jpg"),
  },
  {
    id: "no-pressure",
    title: "No Pressure",
    kind: "Album",
    by: "Logic",
    image: art("Music114/v4/93/4c/ae/934cae30-61cc-bea7-4ed2-39e93bbf5903/20UMGIM60768.rgb.jpg"),
  },
  {
    id: "african-giant",
    title: "African Giant",
    kind: "Album",
    by: "Burna Boy",
    image: art("Music221/v4/8d/58/f1/8d58f169-5f12-3574-3ba1-3a482eefe459/075679849304.jpg"),
  },
  {
    id: "heaven-or-hell",
    title: "Heaven Or Hell",
    kind: "Album",
    by: "Don Toliver",
    image: art("Music115/v4/a5/c2/a5/a5c2a541-9f56-7c98-eb01-3c3198267851/075679823908.jpg"),
  },
  { id: "rediscover", title: "Rediscover Your Liked Songs", kind: "Playlist", by: "Sylvester", image: rediscover },
  { id: "my-playlist-21", title: "My Playlist #21", kind: "Playlist", by: "Sylvester", icon: "note" },
  {
    id: "came-of-age",
    title: "CAME OF AGE",
    kind: "Album",
    by: "O'Kenneth",
    image: art("Music221/v4/d9/ac/a0/d9aca0b8-f3c1-4e28-f329-647843d8c825/827425032924_VLkjhB7-copy-04d63770.png"),
  },
  {
    id: "your-episodes",
    title: "Your Episodes",
    kind: "Playlist",
    by: "Saved & downloaded episodes",
    icon: "episodes",
  },
  {
    id: "all-time-top-songs",
    title: "Your All-Time Top Songs",
    kind: "Playlist",
    by: "Made for Sylvester",
    image: allTimeTopSongs,
  },
  { id: "my-shazam-tracks", title: "My Shazam Tracks", kind: "Playlist", by: "Sylvester", image: shazam },
];

// "More by Drake" under ICEMAN: his other recent albums, newest first.
export const MORE_BY = [
  ["HABIBTI (FOMO)", "2026", "Music221/v4/bb/45/62/bb4562a3-45a2-539c-b557-a18ea060a476/26UMGIM63616.rgb.jpg"],
  ["MAID OF HONOUR", "2026", "Music211/v4/25/c0/e6/25c0e60b-5e99-58b2-6a52-821602141cce/26UMGIM63615.rgb.jpg"],
  ["HABIBTI", "2026", "Music221/v4/c4/3b/89/c43b8964-a24e-b396-bd65-e5b45cabe039/26UMGIM63616.rgb.jpg"],
  ["For All The Dogs", "2023", "Music116/v4/21/50/ee/2150ee84-62c3-4190-7dfa-da30abd98ac8/23UM1IM09862.rgb.jpg"],
  ["Her Loss", "2022", "Music112/v4/c7/00/3f/c7003f83-3a43-1201-4aec-41be71ba64c5/22UM1IM29131.rgb.jpg"],
  ["Honestly, Nevermind", "2022", "Music122/v4/84/2c/b4/842cb419-243c-b3f4-4da9-b6b980996062/22UMGIM67371.rgb.jpg"],
].map(([title, year, path]) => ({ title, year, image: art(path) }));

// The Library's filters, and the kinds of item each shows.
export const FILTERS = {
  Playlists: ["Playlist"],
  Podcasts: ["Podcast"],
  Albums: ["Album", "Compilation"],
  Artists: ["Artist"],
};
